<template>
  <el-form ref="form"
           :model="form"
           label-position="left"
           style="padding:20px;background:#fff"
           label-width="180px">
    <p>用电基本信息</p>
    <el-row :gutter="60">
      <el-col :span="12">
        <el-form-item label="用电单位："
                      prop="eleUnit"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.eleUnit"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="客户售电套餐："
                      prop="setMeals"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-select v-model="form.setMeals"
                     placeholder="请选择">
            <el-option label="一"
                       value="1"></el-option>
            <el-option label="二"
                       value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="客户编号："
                      prop="clientNumber"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.clientNumber"></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="售电套餐自定义：">
          <el-input v-model="form.customSetMeals"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="客户用电编号："
                          prop="clientEleNumber"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.clientEleNumber"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="用电性质："
                      prop="eleNature"
                      :rules="[
      { required: true, message: '不能为空'}]">
          <el-radio-group v-model="form.eleNature">
            <el-radio :label="1">普通工业</el-radio>
            <el-radio :label="2">大工业</el-radio>
            <el-radio :label="3">商业</el-radio>
            <el-radio :label="4">农业</el-radio>
            <el-radio :label="5">居民</el-radio>
            <el-radio :label="6">非居民</el-radio>
            <el-radio :label="7">其他</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="最大需求量(kW·h)："
             prop="maxDemand"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-input v-model="form.maxDemand"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="用电性质自定义：">
          <el-input v-model="form.eleNatureCustom"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="投运日期：">
          <el-date-picker v-model="form.commissionDate"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="12">
      </el-col>

      <el-col :span="12">
        <el-form-item label="电价行业类别：">
          <el-select v-model="form.elePriceType"
                     placeholder="请选择活动区域">
            <el-option label="居民生活用电"
                       :value="1"></el-option>
            <el-option label="大工业用电"
                       :value="2"></el-option>
            <el-option label="一般工商业用电"
                       :value="3"></el-option>
            <el-option label="非工业用电"
                       :value="4"></el-option>
            <el-option label="农业生产用电"
                       :value="5"></el-option>

          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="用电地址：">
          <el-input v-model="form.eleAddress"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="客户电压等级："
                      prop="volLevel"
                      :rules="[
      { required: true, message: '不能为空'}]"
                      required>
          <el-radio-group v-model="form.volLevel">
            <el-radio label="220V"></el-radio>
            <el-radio label="380v"></el-radio>
          </el-radio-group>
          <el-radio-group v-model="form.volLevel">
            <el-radio label="3kv"></el-radio>
            <el-radio label="6.3kv"></el-radio>
            <el-radio label="10kv"></el-radio>
            <el-radio label="20kv"></el-radio>
            <el-radio label="35kv"></el-radio>
            <el-radio label="66kv"></el-radio>
          </el-radio-group>
          <el-radio-group v-model="form.volLevel">
            <el-radio label="110kv"></el-radio>
            <el-radio label="220kv"></el-radio>
            <el-radio label="330kv"></el-radio>
            <el-radio label="500kv"></el-radio>
            <el-radio label="750kv"></el-radio>
            <el-radio label="1000kv"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item>
      <div style="text-align:center">
        <el-button @click="$router.back()">取消</el-button>
        <el-button @click="submitForm('form')"
                   type="primary">保存</el-button>
      </div>

    </el-form-item>
  </el-form>
</template>
<script>
import { postClientEleInfo, putClientEleInfo} from '../../API'
export default {
  data () {
    return {
      form: {
        clientEleNumber: "",
        clientNumber: "",
        commissionDate: "",
        customSetMeals: "",
        eleAddress: "",
        eleInfoId: 0,
        eleNature: "",
        eleNatureCustom: "",
        elePriceType: "",
        eleUnit: "",
        maxDemand: "",
        setMeals: '',
        volLevel: "",
      }
    }
  },
  created () {
    if (localStorage.getItem('ydxx')) {
      this.form = JSON.parse(localStorage.getItem('ydxx'))?JSON.parse(localStorage.getItem('ydxx')):{}
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('eleInfoId')) {
            this.form.clientId = localStorage.getItem('id')
            this.form.eleInfoId = localStorage.getItem('eleInfoId')
            putClientEleInfo(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                  let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
          else {
            this.form.clientId = localStorage.getItem('id')
            postClientEleInfo(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                  let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  },
  destroyed() {
    localStorage.removeItem('ydxx')
  },
}
</script>
<style lang='less' scoped>
.el-row {
  margin: 0 !important;
}
.text {
  font-weight: 650;
  font-style: normal;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid rgb(228, 228, 228);
  text-align: center;
  line-height: normal;
  margin-bottom: 10px;
}
.line {
  height: 1px;
}
</style>